import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { SxProps, Theme } from "@mui/material/styles";

import SVG from "@/assets/svg";
import Styles from "./styles";

const EmptyComponent = ({
  label,
  style,
}: {
  label: string;
  style?: SxProps<Theme>;
}) => {
  return (
    <Styles>
      <Box sx={style} className="Document-upload">
        <SVG.File />
        <Typography>{label}</Typography>
      </Box>
    </Styles>
  );
};

export default EmptyComponent;
